import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import {
  AttendanceMessageDatasetType,
  AttendanceMessageType,
  SectionUserActivityType,
} from "../../shared/types/attendance";

import { createReplaceAllReducer } from "store/utils";

type AttendanceState = {
  sectionUserActivities: Record<string, SectionUserActivityType>;
};

const defaultState: AttendanceState = {
  sectionUserActivities: {},
};

const initialState = () => defaultState;

const updateUserActivityInstance = (state: AttendanceState, activity: SectionUserActivityType) => {
  state.sectionUserActivities[activity.userId] = activity;
};

export const AttendanceStore = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    // TODO: refactor this when we have a better idea of other data we'll be receiving
    updateAnalytics: (state, action: PayloadAction<SectionUserActivityType[]>) => {
      action.payload.forEach((activity) => {
        updateUserActivityInstance(state, activity);
      });
    },
    updateAnalyticsRecord: (state, action: PayloadAction<AttendanceMessageType>) => {
      const activity = action.payload;
      if (activity.datasetType !== AttendanceMessageDatasetType.SECTION_USER_ACTIVITY) return;

      if (activity.removed === "1") {
        delete state.sectionUserActivities[activity.userId];
      } else {
        updateUserActivityInstance(state, activity);
      }
    },
  },
  extraReducers: createReplaceAllReducer<AttendanceState>("attendance", initialState),
});

export const attendanceStateActions = AttendanceStore.actions;
